// Phase 14e-1c — operator-facing role admin surface.
//
// Drives the role dropdown in the rate-card create modal (and any other
// admin form that needs a human-readable role list). v1 has 4 roles
// (PSW / RPN / RN / COMPANION); no pagination needed. activeOnly defaults
// true so the dropdown shows only roles available for v1 contracting;
// the operator can pass activeOnly=false to see the full registered set
// when investigating historical rate cards.
import { z } from 'zod';
/** GET /api/v1/admin/roles — query params. */
export const AdminRoleListQuerySchema = z.object({
    /** Default true: only roles flagged `activeInV1` in the Role table. */
    activeOnly: z
        .union([z.boolean(), z.enum(['true', 'false']).transform((v) => v === 'true')])
        .optional()
        .default(true),
});
/** Single row in the admin role list. */
export const AdminRoleListItemSchema = z.object({
    id: z.string().uuid(),
    code: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    regulatingBody: z.string().nullable(),
    defaultSettingSupport: z.array(z.string()),
    activeInV1: z.boolean(),
});
/** GET /api/v1/admin/roles response — no pagination at v1 scale (4 roles). */
export const AdminRoleListResponseSchema = z.object({
    items: z.array(AdminRoleListItemSchema),
});
//# sourceMappingURL=admin.schema.js.map